import React from "react";
import PropTypes from "prop-types";

import JsonFormDialog from "@components/JsonForm/JsonFormDialog";
import ProgressSpinner from "@components/ProgressSpinner";

import { useCrimesForm } from "./CrimesForm.hooks";

const CrimesForm = ({ sourceDataType, title, data, onHide, onSubmit }) => {
  const { isLoading, config, handleSubmit, initialData } = useCrimesForm({
    sourceDataType,
    data,
    onSubmit,
  });

  return (
    <>
      {isLoading && <ProgressSpinner />}

      <JsonFormDialog
        title={title}
        config={config}
        initialValues={initialData}
        onHide={onHide}
        onSubmit={handleSubmit}
      />
    </>
  );
};

CrimesForm.propTypes = {
  sourceDataType: PropTypes.string,
  title: PropTypes.string,
  data: PropTypes.object,
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default CrimesForm;
